import './slider-product-gallery';
import './slider-creative';
import './slider-team';
import './slider-carousel-cta';
import './slider-training-reviews';
import "./category-image-carousel";
import './slider-popular-training';
import './slider-loop-carousel';
import './product-carousel';
import './inschrijven-grid-card';
import './slider-training-quote';
import "./trainer-testimonials";
